import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useContext, useEffect, useState } from 'react';
import parse from 'html-react-parser';
import { localizationContext } from './localizationContext';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export function Translate(props) {
  var params = props.params,
    _props$paramsWithDang = props.paramsWithDangerousHtml,
    paramsWithDangerousHtml = _props$paramsWithDang === void 0 ? false : _props$paramsWithDang,
    text = props.text;
  var context = useContext(localizationContext);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    translated = _useState2[0],
    setTranslated = _useState2[1];
  useEffect(function () {
    var isActive = true;
    if (context) {
      if (text.indexOf('.') < 1) {
        if (context.showLogs) console.warn("Invalid translate key '".concat(text, "'"));
        setTranslated(text);
      } else {
        context.localizationService.translate(text, {
          interpolateParams: params
        }).then(function (res) {
          if (isActive) {
            setTranslated(res);
          }
        })["catch"]();
      }
    }
    return function () {
      isActive = false;
    };
  }, [context, params, text]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: paramsWithDangerousHtml ? parse(translated) : translated
  });
}